import { render, staticRenderFns } from "./GestioneNewsBroker.vue?vue&type=template&id=10499eac&scoped=true&"
import script from "./GestioneNewsBroker.vue?vue&type=script&lang=js&"
export * from "./GestioneNewsBroker.vue?vue&type=script&lang=js&"
import style0 from "./GestioneNewsBroker.vue?vue&type=style&index=0&id=10499eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10499eac",
  null
  
)

export default component.exports